var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCronaLon = function SvgCronaLon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 320 320"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#F97820",
    d: "M254.17 278.3h-37.66l65.87-180.46H320zm-188.31 0h37.67L37.66 97.84H0zM209 41l-49 134.11-28.2-77.27H94.15L160 278.29 246.63 41z"
  })));
};
export default SvgCronaLon;